export interface ResponseSettingJob {
  _id: string;
  paramsForRunAgain: Record<string, any>;
  taskName: string;
  detail: string;
  fromModule: string;
  jobStartTime: string;
  jobEndTime: string;
  status: SettingJobStatusEnum;
  error: string;
  response: string;
  informationJob: InformationJob;
  createdAt: string;
  updatedAt: string;
  schedule: string;
}

export interface InformationJob {
  companyId?: string;
  taskName?: string;
  year?: number;
  selectedMonths?: string[];
  yearFrom: number;
  yearTo: number;
}

export enum SettingJobStatusEnum {
  SUCCESS = "Success",
  FAIL = "Fail",
  RUNNING = "Running",
}

export enum JobFromModule {
  TAG_PI_WARMUP = "tag-pi,warmup",
  FLARE_CALCULATE = "flare,calculate",
  FUGITIVE_IMPORT_TPE = "fugitive,import-tpe-data",
  FUGITIVE_DELETE_SCGC = "fugitive,delete-data-fugitive",
  FUGITIVE_RE_CALCULATE_VOCS_STATUS = "fugitive,re-calculate-vocs-status",
  FUGITIVE_RE_CALCULATE_SUMMARY_REPORT = "fugitive,re-calculate-summary-report-vocs",
  FUGITIVE_RE_MAPPING_AREA = "fugitive,re-mapping-master-area",
  FUGITIVE_CLEAN_DATA = "fugitive,clean-data-fugitive",
  COMBUSTION_CALCULATE = "combustion,calculate-report",
  PRODUCTION_IMPORT_DATA = "production,import-data",
  VOC_DUPLICATE_DATA = "voc,duplicate-data",
  FUGITIVE_IMPORT_DATA = "fugitive,import-data",
}

export const filteredStatus = [
  { text: SettingJobStatusEnum.FAIL, value: SettingJobStatusEnum.FAIL },
  { text: SettingJobStatusEnum.RUNNING, value: SettingJobStatusEnum.RUNNING },
  { text: SettingJobStatusEnum.SUCCESS, value: SettingJobStatusEnum.SUCCESS },
];

export const LISTS_TAGPI_COMPANY_JOB = ["MOC", "ROC", "TPE"];
export const LISTS_RELATE_TAG_PI_JOB = [JobFromModule.COMBUSTION_CALCULATE, JobFromModule.FLARE_CALCULATE];
export const LISTS_RELATE_PRODUCTION_JOB = [JobFromModule.PRODUCTION_IMPORT_DATA];
export const LISTS_RELATE_FUGITIVE_JOB = [
  JobFromModule.FUGITIVE_IMPORT_TPE,
  JobFromModule.FUGITIVE_RE_CALCULATE_VOCS_STATUS,
  JobFromModule.FUGITIVE_RE_CALCULATE_SUMMARY_REPORT,
  JobFromModule.FUGITIVE_RE_MAPPING_AREA,
  JobFromModule.FUGITIVE_IMPORT_DATA,
];

export interface QueryTagPIJob {
  // companyName is optional for reRunJob in case of dev environment testing
  companyName?: string;
  companyId?: string;
  isUpdateCurrentMonth?: boolean;
  startDate?: string;
  endDate?: string;
  taskName?: string;
  selectedMonths?: string[];
  year?: number;
}

export interface QueryDuplicateJob {
  companyId?: string;
  taskName?: string;
  yearFrom?: number;
  yearTo?: number;
}
